var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'wrapper',
    {
      'desktop-hidden-sidebar': _vm.desktopHideSidebar,
      'mobile-show-sidebar': _vm.mobileShowSidebar,
    } ]},[_c('AppMenu',{attrs:{"model":_vm.menu},on:{"menuitem-click":_vm.onMenuItemClick,"menu-toggle":_vm.onMenuToggle}}),(_vm.showTopbar)?_c('AppTopbar',{attrs:{"showHamburger":_vm.showHamburger},on:{"menu-toggle":_vm.onMenuToggle}}):_c('PrintTopbar'),_c('div',{staticClass:"content"},[_c('div',{class:_vm.routerviewClass},[_c('router-view')],1),(_vm.showTopbar)?_c('AppFooter'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }